import { render, staticRenderFns } from "./MensajeRecuadro.vue?vue&type=template&id=acca877c&scoped=true&"
import script from "./MensajeRecuadro.vue?vue&type=script&lang=js&"
export * from "./MensajeRecuadro.vue?vue&type=script&lang=js&"
import style0 from "./MensajeRecuadro.vue?vue&type=style&index=0&id=acca877c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acca877c",
  null
  
)

export default component.exports